module.exports = __webpack_public_path__ + "static/media/SPONSORS (4).e4a39148.png";